import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from 'vue';
import { VMoney } from 'v-money';
import { Decimal } from 'decimal.js';

import {
  SingleInput,
  ShortcutValue,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';

import { currencyToNumber } from '@/modules/common/helpers/currency';
import { IShortcutValue, EShortcutType } from './types';

interface Props {
  shortcutValue: IShortcutValue[];
  status?: string;
  value?: string;
  helperText?: string;
  minimum?: number;
  increment?: number;
  showButtons?: boolean;
  updateValue?: boolean;
  loading?: boolean;
}
interface EmitEvents {
  (
    event: 'change',
    data: { value: number; formatted: string; increment: boolean }
  ): void;
  (event: 'blur'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputMoney',
  props: {
    shortcutValue: null,
    status: { default: '' },
    value: { default: '' },
    helperText: { default: '' },
    minimum: { default: 0 },
    increment: { default: 0 },
    showButtons: { type: Boolean, default: false },
    updateValue: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["change", "blur"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'change',
    data: { value: number; formatted: string; increment: boolean }
  ): void;
  (event: 'blur'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { shortcutValue: IShortcutValue[], status: string, value: string, helperText: string, minimum: number, increment: number, showButtons: boolean, updateValue: boolean, loading: boolean }

const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
const numberFormat = new Intl.NumberFormat('pt-BR', options);





const moneyValueFormatted = ref('');
const moneyValue = ref(0);

function handleChange(event: Event) {
  const target = event.target as HTMLInputElement;

  moneyValueFormatted.value = target.value.replace('-', '');
  moneyValue.value = currencyToNumber(moneyValueFormatted.value);

  emitChange();
}

function onClear() {
  moneyValueFormatted.value = '0,00';
  moneyValue.value = 0;

  emitChange();
}

function shortcutClick(data: IShortcutValue) {
  const shortCutValue = new Decimal(data.value);
  const currentValue = new Decimal(moneyValue.value);

  if (data.type === EShortcutType.SET) {
    moneyValueFormatted.value = numberFormat.format(shortCutValue.toNumber());
    moneyValue.value = shortCutValue.toNumber();
  } else {
    moneyValueFormatted.value = numberFormat.format(
      currentValue.plus(shortCutValue).toNumber()
    );
    moneyValue.value = currentValue.plus(shortCutValue).toNumber();
  }

  emitChange(true);
}

function incrementClick() {
  const currentValue = new Decimal(moneyValue.value);
  const increment = new Decimal(props.increment);

  if (currentValue.toNumber() < props.minimum) {
    moneyValueFormatted.value = numberFormat.format(props.minimum);
    moneyValue.value = props.minimum;

    emitChange(true);
    return;
  }

  const finalValue = currentValue.plus(increment).toDecimalPlaces(2).toNumber();

  moneyValueFormatted.value = numberFormat.format(finalValue);
  moneyValue.value = finalValue;

  emitChange(true);
}

function decrementClick() {
  const currentValue = new Decimal(moneyValue.value);
  const descrement = new Decimal(props.increment);

  if (currentValue.toNumber() <= props.minimum) {
    moneyValueFormatted.value = numberFormat.format(0);
    moneyValue.value = 0;

    emitChange(true);
    return;
  }

  const calcValue = currentValue.minus(descrement).toNumber();
  const finalValue = calcValue < 1 ? 0 : calcValue;

  moneyValueFormatted.value = numberFormat.format(finalValue);
  moneyValue.value = finalValue;

  emitChange(true);
}

function emitChange(increment = false) {
  const data = {
    value: moneyValue.value,
    formatted: moneyValueFormatted.value,
    increment
  };

  emit('change', data);
}

watch(
  () => props.updateValue,
  updateValue => {
    if (updateValue) {
      moneyValueFormatted.value = props.value.replace('R$', '').trim();
      moneyValue.value = currencyToNumber(props.value);
    }
  },
  { immediate: true }
);

onMounted(() => {
  const textarea = document.querySelector('textarea') as HTMLElement;
  VMoney(textarea, {
    value: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      precision: 2
    }
  });
});

return { __sfc: true,options, numberFormat, props, emit, moneyValueFormatted, moneyValue, handleChange, onClear, shortcutClick, incrementClick, decrementClick, emitChange, SingleInput, ShortcutValue, ButtonIconContextual }
}

})